const costaRica = [
  { "code": "San José", "name": "San José" },
  { "code": "Provincia de Alajuela", "name": "Alajuela" },
  { "code": "Provincia de Cartago", "name": "Cartago" },
  { "code": "Heredia Province", "name": "Heredia" },
  { "code": "Provincia de Guanacaste", "name": "Guanacaste" },
  { "code": "Puntarenas Province", "name": "Puntarenas" },
  { "code": "Limón", "name": "Limón" },
]
export default costaRica;